// Dining interest form (CF7). Two bits of behaviour the form tags can't express:
// the city field only applies when the event is at the guest's own place, and the
// guest count gets a Greek message instead of the browser's default min warning.
// Server-side counterpart: inc/dining-form.php.
const AT_YOUR_SPACE = 'At Your Space';
const MIN_GUESTS = 8;

document.querySelectorAll('.dining-form form').forEach((form) => {
  const area = form.querySelector('[name="event-area"]');
  const cityField = form.querySelector('[data-city-field]');
  const city = cityField && cityField.querySelector('select');

  if (area && city) {
    const areaField = area.closest('p');

    // Hidden fields are never required, so the pair always moves together.
    const syncCity = () => {
      const atGuestSpace = area.value === AT_YOUR_SPACE;
      cityField.hidden = !atGuestSpace;
      city.required = atGuestSpace;
      if (!atGuestSpace) city.value = '';
      // With the city gone, nothing can sit beside the area field — the next
      // field is full-width — so let it span the row instead of leaving a hole.
      if (areaField) areaField.classList.toggle('df-full', !atGuestSpace);
    };

    area.addEventListener('change', syncCity);
    // CF7 clears the form after a successful send; re-hide the city field.
    document.addEventListener('wpcf7mailsent', syncCity);
    syncCity();
  }

  const people = form.querySelector('[name="people"]');
  if (people) {
    const checkGuests = () => {
      const tooFew = people.value !== '' && Number(people.value) < MIN_GUESTS;
      people.setCustomValidity(tooFew ? `Ελάχιστος αριθμός ατόμων: ${MIN_GUESTS}.` : '');
    };

    people.addEventListener('input', checkGuests);
    people.addEventListener('invalid', checkGuests);
  }
});
